import { Scanner } from '@/components/scanner';
import { MobileContainer } from '@/components/workflow/mobile-container';
import { MobileHeader } from '@/components/workflow/mobile-header';
import { WorkflowFooter } from '@/components/workflow/workflow-footer';
import { Button, Flex, Text } from '@mantine/core';
import { useNavigate } from '@tanstack/react-router';
import { useBagScanContext } from '../hook';
import styles from '../styles.module.css';

export const BagScanScanPage = () => {
	const { handleScan, setPage, sessionState } = useBagScanContext();
	const navigate = useNavigate();

	return (
		<MobileContainer
			header={<MobileHeader title="Bag Scan" onClose={() => navigate({ to: '/facility/home' })} />}
			footer={
				<WorkflowFooter
					secondaryContent={
						<Flex px="md" py="xs" w="100%" align="center" justify="center" gap="xs">
							<Flex
								gap="xs"
								align="center"
								justify="center"
								flex={1}
								p="sm"
								className={styles.statsCardAccepted}
							>
								<Text size="lg" c="green">
									✅
								</Text>
								<Flex direction="column" align="center" gap={2}>
									<Text size="lg" fw={700} c="green" lh={1}>
										{sessionState.accepted}
									</Text>
									<Text size="xs" c="green" fw={500} lh={1}>
										Accepted
									</Text>
								</Flex>
							</Flex>
							<Flex
								gap="xs"
								align="center"
								justify="center"
								flex={1}
								p="sm"
								className={styles.statsCardRejected}
							>
								<Text size="lg" c="red">
									❌
								</Text>
								<Flex direction="column" align="center" gap={2}>
									<Text size="lg" fw={700} c="red" lh={1}>
										{sessionState.rejected}
									</Text>
									<Text size="xs" c="red" fw={500} lh={1}>
										Rejected
									</Text>
								</Flex>
							</Flex>
							<Flex
								gap="xs"
								align="center"
								justify="center"
								flex={1}
								p="sm"
								className={styles.statsCardAudited}
							>
								<Text size="lg" c="white">
									🔍
								</Text>
								<Flex direction="column" align="center" gap={2}>
									<Text size="lg" fw={700} c="white" lh={1}>
										{sessionState.audited}
									</Text>
									<Text size="xs" c="white" fw={500} lh={1}>
										Audited
									</Text>
								</Flex>
							</Flex>
						</Flex>
					}
				>
					<Button
						onClick={() => setPage('MANUAL')}
						size="md"
						variant="filled"
						bg="grey"
						c="white"
						fullWidth
					>
						Enter Code
					</Button>
					<Button
						onClick={() => navigate({ to: '/facility/home' })}
						size="md"
						variant="filled"
						fullWidth
					>
						Done
					</Button>
				</WorkflowFooter>
			}
		>
			<Scanner onScan={handleScan} />
		</MobileContainer>
	);
};
